import {notification} from 'antd'
import {UserService} from '../services'
import i18nextConfig from '../config/i18next'

export default (passwordCurrent, passwordNew, passwordNewConfirm) => {
    return new Promise(async resolve => {
        if (passwordNew !== passwordNewConfirm) {
            notification['error']({message: i18nextConfig.t('messages.aml.errors.passwordsDontMatch')})
        } else {
            await UserService.changePwd(passwordCurrent, passwordNew)
                .then(response => {
                    if (response.status === 201 || response.status === 202) { //responseCode -> 202-00
                        notification['success'](
                            {message: i18nextConfig.t('messages.aml.success.passwordSuccesfullyUpdated')})
                        resolve(true)
                    }
                })
                .catch(data => {
                    const errorMessages = {
                        "400-10": 'messages.aml.errors.passwordCannotBeInLogin',
                        "400-20": 'messages.aml.errors.passwordMustHaveBetween8and30Chars',
                        "400-30": 'messages.aml.errors.passwordMustBeAlphanumeric',
                        "400-40": 'messages.aml.errors.passwordMustHaveLowerCaseLetter',
                        "400-50": 'messages.aml.errors.passwordMustHaveUpperCaseLetter',
                        "400-60": 'messages.aml.errors.youCannotUsePreviousPasswords',
                        "400-70": 'messages.aml.errors.invalid.current.pwd',
                        "400-80": 'messages.aml.errors.newPwdIdenticalToCurrent',
                        "500": 'messages.aml.errors.unknownError'
                    };

                    const validationMessage = errorMessages[data.response.data.code] || 'messages.aml.errors.unknownError';
                    notification['error']({message: i18nextConfig.t(validationMessage)});
                })
        }
    })
}
